import { render, staticRenderFns } from "./EditItemBrain.vue?vue&type=template&id=5cdb3dee"
import script from "./EditItemBrain.vue?vue&type=script&lang=js"
export * from "./EditItemBrain.vue?vue&type=script&lang=js"
import style0 from "./EditItemBrain.vue?vue&type=style&index=0&id=5cdb3dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports